import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Cpu, Unlock, Zap } from 'lucide-react';
export function RevelationSection() {
  return <SectionWrapper className="bg-cyber-dark/80 relative" data-id="element-255">
      {/* Decorative side lines */}
      <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-cyber-neon to-transparent opacity-30" data-id="element-256"></div>
      <div className="absolute right-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-cyber-neon to-transparent opacity-30" data-id="element-257"></div>

      <div className="text-center mb-16" data-id="element-258">
        <h2 className="text-3xl md:text-5xl text-white mb-6 font-mono" data-id="element-259">
          LA{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-260">REVELACIÓN</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-261">
          La mayoría de los psicólogos te dirán que "respires profundo".
          Spoiler: <strong className="text-cyber-red" data-id="element-262">Eso no funciona.</strong>
        </p>
      </div>

      <div className="bg-cyber-black border border-cyber-neon/30 p-8 md:p-12 rounded-xl shadow-[0_0_30px_rgba(57,255,20,0.05)] relative" data-id="element-263">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-cyber-black px-4 text-cyber-neon font-mono text-sm border border-cyber-neon/50 rounded-full" data-id="element-264">
          DECRYPTING_SOLUTION...
        </div>

        <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-265">
          La ansiedad social no se cura pensando; se cura{' '}
          <strong className="text-cyber-neon" data-id="element-266">
            hackeando el sistema nervioso
          </strong>
          . Descubrimos que la Gen Z procesa la interacción social de forma
          diferente debido a la sobreexposición digital.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-267">
          <div className="flex gap-4" data-id="element-268">
            <div className="w-12 h-12 rounded-full bg-cyber-neon/10 border border-cyber-neon flex items-center justify-center shrink-0" data-id="element-269">
              <Zap className="text-cyber-neon w-6 h-6" data-id="element-270" />
            </div>
            <div data-id="element-271">
              <h4 className="text-white font-mono font-bold mb-2" data-id="element-272">
                Micro-Exposición Programada
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-273">
                La solución no es "ser valiente". Mediante pequeños "hacks" de 3
                segundos, engañamos a tu amígdala para que deje de enviar
                señales de pánico.
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-274">
            <div className="w-12 h-12 rounded-full bg-cyber-neon/10 border border-cyber-neon flex items-center justify-center shrink-0" data-id="element-275">
              <Cpu className="text-cyber-neon w-6 h-6" data-id="element-276" />
            </div>
            <div data-id="element-277">
              <h4 className="text-white font-mono font-bold mb-2" data-id="element-278">
                Ciencia, no Motivación
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-279">
                Es pasar de ser un "NPC" (personaje secundario) a ser el
                protagonista de tu propia vida usando el código correcto.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-280">
          <div className="inline-flex items-center gap-2 text-cyber-neon font-mono border-b border-cyber-neon pb-1" data-id="element-281">
            <Unlock className="w-4 h-4" data-id="element-282" />
            <span data-id="element-283">ACCESO AL CÓDIGO FUENTE DESBLOQUEADO</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}